import api from "./api"
import store from "../store/index"

export async function getItems({ search }) {
  const result = await api.get(`/api/v1/items/Search/`, {
    params: {
      search,
      customerID: store.state.customerID,
    },
  })

  return result.data
}
